import { render } from "./ticketsThrowDialog.vue?vue&type=template&id=6b1bc35f"
import script from "./ticketsThrowDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsThrowDialog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/ticketsThrowDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b1bc35f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b1bc35f', __exports__)) {
    console.log('reload')
    api.reload('6b1bc35f', __exports__)
  }
  
  module.hot.accept("./ticketsThrowDialog.vue?vue&type=template&id=6b1bc35f", () => {
    console.log('re-render')
    api.rerender('6b1bc35f', render)
  })

}


export default __exports__